import { useEffect } from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const useDocTitle = (title) => {
  useEffect(() => {
    document.title = title
      ? `${title} — Studio Solutions LLC`
      : "Studio Solutions LLC — Creative Production. Live Execution. Wisconsin.";
  }, [title]);
};

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, dark = false, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    {eyebrow && (
      <p className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-gold" : "text-gold-dark"}`}>
        {eyebrow}
      </p>
    )}
    <h2
      className={`headline mt-4 font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-5xl ${
        dark ? "text-sand" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {sub && (
      <p className={`mt-5 font-serif text-lg italic sm:text-2xl ${dark ? "text-sand/60" : "text-smoke"}`}>
        {sub}
      </p>
    )}
  </Reveal>
);
